import { createAction, props } from '@ngrx/store';
import { MachineActivity } from '../_models/machinaries/machineActivity';

// Action types
export const loadMachineActivities = createAction('[MachineActivity] Load MachineActivities');
export const loadMachineActivitiesSuccess = createAction(
  '[MachineActivity] Load MachineActivities Success',
  props<{ machineActivities: MachineActivity[] }>()
);
export const loadMachineActivitiesFailure = createAction(
  '[MachineActivity] Load MachineActivities Failure',
  props<{ error: any }>()
);

export const addMachineActivity = createAction(
  '[MachineActivity] Add MachineActivity',
  props<{ machineActivity: MachineActivity }>()
);
export const addMachineActivitySuccess = createAction(
  '[MachineActivity] Add MachineActivity Success',
  props<{ machineActivity: MachineActivity }>()
);
export const addMachineActivityFailure = createAction(
  '[MachineActivity] Add MachineActivity Failure',
  props<{ error: any }>()
);

export const updateMachineActivity = createAction(
  '[MachineActivity] Update MachineActivity',
  props<{ machineActivity: MachineActivity }>()
);
export const updateMachineActivitySuccess = createAction(
  '[MachineActivity] Update MachineActivity Success',
  props<{ machineActivity: MachineActivity }>()
);
export const updateMachineActivityFailure = createAction(
  '[MachineActivity] Update MachineActivity Failure',
  props<{ error: any }>()
);

export const deleteMachineActivity = createAction(
  '[MachineActivity] Delete MachineActivity',
  props<{ id: number }>()
);
export const deleteMachineActivitySuccess = createAction(
  '[MachineActivity] Delete MachineActivity Success',
  props<{ id: number }>()
);
export const deleteMachineActivityFailure = createAction(
  '[MachineActivity] Delete MachineActivity Failure',
  props<{ error: any }>()
);
